import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import DatePicker from 'components/DatePicker';
import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import SheetActionButton from 'components/Layout/MobileShell/SheetActionButton';
import CalendarioLegenda from 'components/Relatorios/shared/Aprovacao/CalendarioLegenda';
import { DessemControlPanelState } from 'hooks/Relatorios/Dessem/useDessemControlPanel';

import './index.scss';

export interface DessemControlPanelSheetProps extends DessemControlPanelState {
  open: boolean;
  dismiss: () => void;
}

/**
 * Painel de controle do Informe DESSEM no mobile (BottomSheet). Só apresenta: o estado e as
 * ações vêm do `useDessemControlPanel`, chamado uma única vez no `ConsultaCard` (sempre montado),
 * porque o conteúdo do BottomSheet não monta com ele fechado e o efeito D1 do hook precisa rodar
 * mesmo assim. Como no desktop, não há "Atualizar": clicar num dia ou num cenário já aplica;
 * "Aplicar filtros" só fecha a folha. Os dois blocos começam abertos (cada um recolhe sozinho).
 */
export default function DessemControlPanelSheet({
  open,
  dismiss,
  selecionada,
  handleDataChange,
  maxData,
  datePickerProps,
  mostraLegenda,
  cenarios,
  carregando,
  cenarioAplicado,
  handleCenarioChange,
}: DessemControlPanelSheetProps) {
  const [dataAberta, setDataAberta] = useState(true);
  const [cenarioAberto, setCenarioAberto] = useState(true);

  // Cada abertura da folha volta com os dois blocos expandidos.
  useEffect(() => {
    if (open) {
      setDataAberta(true);
      setCenarioAberto(true);
    }
  }, [open]);

  const cenarioSelecionado = cenarios.find((c) => c.value === cenarioAplicado);

  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Painel de controle"
      className="dessem-control-panel-sheet"
    >
      <div className="dessem-control-panel-sheet-body">
        <Section
          label="Data do Informe"
          valueText={format(selecionada, 'dd/MM/yyyy')}
          open={dataAberta}
          onToggle={() => setDataAberta((aberta) => !aberta)}
        >
          <DatePicker
            inline
            selected={selecionada}
            onChange={handleDataChange}
            maxDate={maxData}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...datePickerProps}
          />
          {mostraLegenda && <CalendarioLegenda isAdmin />}
        </Section>

        <Section
          label="Cenário"
          valueText={cenarioSelecionado?.label}
          open={cenarioAberto}
          onToggle={() => setCenarioAberto((aberto) => !aberto)}
        >
          {cenarios.map(({ value, label, disponivel }) => (
            <OptionRow
              key={value}
              label={label}
              selected={cenarioAplicado === value}
              disabled={carregando || !disponivel}
              onSelect={() => handleCenarioChange(value)}
            />
          ))}
        </Section>
      </div>

      <div className="dessem-control-panel-sheet-footer">
        <SheetActionButton variant="confirm" onClick={dismiss}>
          Aplicar filtros
        </SheetActionButton>
      </div>
    </BottomSheet>
  );
}
